import { FunctionComponent, useState } from "react"
import { Button, Col, Modal, Row, Table } from "react-bootstrap"
import Container from "react-bootstrap/Container"
import { useNavigate } from "react-router-dom"
import FilterField from "../components/FilterField"
import { Door } from "../data/models.interface"
import { useGetDoorsQuery } from "../hooks/queries/useGetDoorsQuery"
import { useOpenDoorQuery } from "../hooks/queries/useOpenDoorQuery"
import useSessionStorage from "../hooks/useSessionStorage"
import useSort from "../hooks/useSort"
import { filterProperty } from "../utils/StringUtils"

interface IOpenDoorPage {}
const OpenDoorPage: FunctionComponent<IOpenDoorPage> = () => {
	const doorsQuery = useGetDoorsQuery()
	const doors = doorsQuery.data?.doors
	// loading layout
	if (!doors) return <LoadingLayout />
	// normal layout
	return (
		<Container>
			<h2 className="text-center mt-4">Unlock Door</h2>
			<DoorsTable doors={doors} />

			<Row>
				<Col xs="auto">
					<BackButton />
				</Col>
				<Col />
			</Row>
		</Container>
	)
}
export default OpenDoorPage

const LoadingLayout = () => {
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Unlock Door</h2>
			<div className="text-center">Loading</div>
		</Container>
	)
}

interface IDoorsTable {
	doors: Door[]
}
const DoorsTable = ({ doors }: IDoorsTable) => {
	const [nameFilter, setNameFilter] = useSessionStorage("doors-name", "")
	const { sortBy, sort } = useSort<Door>("name")
	doors = filterProperty(doors, (d) => d.fullName!, nameFilter)
	doors = sort(doors)
	//
	const [door, setDoor] = useState<Door | undefined>()
	//
	return (
		<>
			<OpenDoorModal door={door} onHide={() => setDoor(undefined)} />
			<Table striped bordered hover size="sm">
				<thead>
					<tr>
						<th onClick={() => sortBy("fullName")}>Name</th>
					</tr>
					<tr>
						<td>
							<FilterField filter={nameFilter} setFilter={setNameFilter} placeholder="Search" />
						</td>
					</tr>
				</thead>
				<tbody>
					{doors?.map((door) => (
						<tr key={door.id} onClick={() => setDoor(door)}>
							<td>{door.fullName}</td>
						</tr>
					))}
				</tbody>
			</Table>
		</>
	)
}

interface IOpenDoorModal {
	door?: Door
	onHide: () => void
}
const OpenDoorModal: FunctionComponent<IOpenDoorModal> = ({ door, onHide }) => {
	const { query } = useOpenDoorQuery(door?.id || "")
	return (
		<Modal show={door != null} onHide={onHide}>
			<Modal.Header closeButton={true}>
				<Modal.Title>Unlock Door</Modal.Title>
			</Modal.Header>
			<Modal.Body>Unlock {door?.fullName}?</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={onHide}>
					Cancel
				</Button>
				<Col></Col>
				<Button variant="primary" onClick={() => query().then(() => onHide())}>
					Unlock
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

const BackButton = () => {
	const navigate = useNavigate()
	return (
		<Button variant="secondary" className="mb-3" onClick={() => navigate(-1)}>
			Back
		</Button>
	)
}
